/**
 * List test Adapters to abstract common unit test actions away from the implementation details.
 */

import { fireEvent, screen } from '@testing-library/preact';

export const mouseItemSelection = (element: HTMLElement, options?: Record<string, unknown>) => {
  fireEvent.click(element, options);
};

export const mouseCheckboxSelection = (itemIndex: number, options?: Record<string, unknown>) => {
  // we are looking for the checkbox icon when handling click events
  const checkboxes = screen.getAllByRole('img', { hidden: true });
  const checkbox = checkboxes[itemIndex];
  if (checkbox) {
    if (typeof jest !== typeof undefined) {
      fireEvent.click(checkbox, options);
    } else {
      setTimeout(() => {
        fireEvent.click(checkbox, options);
      }, 100);
    }
  } else {
    throw new Error('Cannot find checkbox!');
  }
};

export const getRoot = async (role = 'grid') => {
  return screen.findByRole(role);
};

export const getItems = async (role = 'row') => {
  return screen.findAllByRole(role);
};

export const getContents = async (role = 'gridcell') => {
  return screen.findAllByRole(role);
};

export const fireDragAndDropEvent = (dragElement: HTMLElement, dropElement: HTMLElement) => {
  fireEvent.dragStart(dragElement);
  fireEvent.dragEnter(dropElement);
  fireEvent.drop(dropElement);
  fireEvent.dragEnd(dragElement);
};

export const keyboardReorder = (element: HTMLElement, keyCode: 'ArrowUp' | 'ArrowDown') => {
  fireEvent.keyDown(element, {
    key: keyCode,
    code: keyCode,
    shiftKey: true,
    metaKey: true
  });
};
